var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.999,
    height: 18.999,
    viewBox: "0 0 18.999 18.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-calendar-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1899",
    "data-name": "Rectangle 1899",
    width: 18.999,
    height: 18.999,
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21563",
    "data-name": "Group 21563",
    transform: "translate(0.497 0.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21562",
    "data-name": "Group 21562",
    transform: "translate(-0.497 -0.628)",
    clipPath: "url(#clip-path-calendar-icon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11090",
    "data-name": "Path 11090",
    d: "M130.374,180.748h.374a.374.374,0,0,0,0-.749h-.374a.374.374,0,1,0,0,.749",
    transform: "translate(-124.967 -172.978)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11091",
    "data-name": "Path 11091",
    d: "M200.374,180.748h.374a.374.374,0,1,0,0-.749h-.374a.374.374,0,1,0,0,.749",
    transform: "translate(-192.348 -172.978)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11092",
    "data-name": "Path 11092",
    d: "M270.374,180.748h.374a.374.374,0,1,0,0-.749h-.374a.374.374,0,1,0,0,.749",
    transform: "translate(-259.728 -172.978)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11093",
    "data-name": "Path 11093",
    d: "M340.374,180.748h.374a.374.374,0,1,0,0-.749h-.374a.374.374,0,1,0,0,.749",
    transform: "translate(-327.108 -172.978)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11094",
    "data-name": "Path 11094",
    d: "M410.374,180.748h.374a.374.374,0,1,0,0-.749h-.374a.374.374,0,1,0,0,.749",
    transform: "translate(-394.488 -172.978)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11095",
    "data-name": "Path 11095",
    d: "M60.374,240.749h.374a.374.374,0,0,0,0-.749h-.374a.374.374,0,0,0,0,.749",
    transform: "translate(-57.587 -230.732)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11096",
    "data-name": "Path 11096",
    d: "M130.374,240.749h.374a.374.374,0,0,0,0-.749h-.374a.374.374,0,1,0,0,.749",
    transform: "translate(-124.967 -230.732)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11097",
    "data-name": "Path 11097",
    d: "M200.374,240.749h.374a.374.374,0,0,0,0-.749h-.374a.374.374,0,0,0,0,.749",
    transform: "translate(-192.348 -230.732)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11098",
    "data-name": "Path 11098",
    d: "M270.374,240.749h.374a.374.374,0,1,0,0-.749h-.374a.374.374,0,1,0,0,.749",
    transform: "translate(-259.728 -230.732)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11099",
    "data-name": "Path 11099",
    d: "M340.374,240.749h.374a.374.374,0,0,0,0-.749h-.374a.374.374,0,1,0,0,.749",
    transform: "translate(-327.108 -230.732)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11100",
    "data-name": "Path 11100",
    d: "M410.374,240.749h.374a.374.374,0,0,0,0-.749h-.374a.374.374,0,0,0,0,.749",
    transform: "translate(-394.488 -230.732)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11101",
    "data-name": "Path 11101",
    d: "M60.374,300.749h.374a.374.374,0,1,0,0-.749h-.374a.374.374,0,0,0,0,.749",
    transform: "translate(-57.587 -288.486)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11102",
    "data-name": "Path 11102",
    d: "M130.374,300.749h.374a.374.374,0,0,0,0-.749h-.374a.374.374,0,1,0,0,.749",
    transform: "translate(-124.967 -288.486)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11103",
    "data-name": "Path 11103",
    d: "M200.374,300.749h.374a.374.374,0,0,0,0-.749h-.374a.374.374,0,0,0,0,.749",
    transform: "translate(-192.348 -288.486)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11104",
    "data-name": "Path 11104",
    d: "M270.374,300.749h.374a.374.374,0,1,0,0-.749h-.374a.374.374,0,1,0,0,.749",
    transform: "translate(-259.728 -288.486)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11105",
    "data-name": "Path 11105",
    d: "M340.374,300.749h.374a.374.374,0,0,0,0-.749h-.374a.374.374,0,1,0,0,.749",
    transform: "translate(-327.108 -288.486)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11106",
    "data-name": "Path 11106",
    d: "M410.374,300.749h.374a.374.374,0,0,0,0-.749h-.374a.374.374,0,0,0,0,.749",
    transform: "translate(-394.488 -288.486)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11107",
    "data-name": "Path 11107",
    d: "M60.374,360.748h.374a.374.374,0,1,0,0-.749h-.374a.374.374,0,1,0,0,.749",
    transform: "translate(-57.587 -346.241)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11108",
    "data-name": "Path 11108",
    d: "M130.374,360.748h.374a.374.374,0,0,0,0-.749h-.374a.374.374,0,1,0,0,.749",
    transform: "translate(-124.967 -346.241)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11109",
    "data-name": "Path 11109",
    d: "M200.374,360.748h.374a.374.374,0,1,0,0-.749h-.374a.374.374,0,1,0,0,.749",
    transform: "translate(-192.348 -346.241)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11110",
    "data-name": "Path 11110",
    d: "M270.374,360.748h.374a.374.374,0,1,0,0-.749h-.374a.374.374,0,1,0,0,.749",
    transform: "translate(-259.728 -346.241)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11111",
    "data-name": "Path 11111",
    d: "M340.374,360.748h.374a.374.374,0,0,0,0-.749h-.374a.374.374,0,1,0,0,.749",
    transform: "translate(-327.108 -346.241)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11112",
    "data-name": "Path 11112",
    d: "M410.374,360.748h.374a.374.374,0,0,0,0-.749h-.374a.374.374,0,0,0,0,.749",
    transform: "translate(-394.488 -346.241)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11113",
    "data-name": "Path 11113",
    d: "M60.374,420.748h.374a.374.374,0,1,0,0-.748h-.374a.374.374,0,1,0,0,.748",
    transform: "translate(-57.587 -403.995)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11114",
    "data-name": "Path 11114",
    d: "M130.374,420.748h.374a.374.374,0,1,0,0-.748h-.374a.374.374,0,1,0,0,.748",
    transform: "translate(-124.967 -403.995)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11115",
    "data-name": "Path 11115",
    d: "M200.374,420.748h.374a.374.374,0,1,0,0-.748h-.374a.374.374,0,1,0,0,.748",
    transform: "translate(-192.348 -403.995)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11116",
    "data-name": "Path 11116",
    d: "M270.374,420.748h.374a.374.374,0,1,0,0-.748h-.374a.374.374,0,1,0,0,.748",
    transform: "translate(-259.728 -403.995)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11117",
    "data-name": "Path 11117",
    d: "M18.339,1.5H16.468V1.31a1.31,1.31,0,1,0-2.62,0V1.5H4.865V1.31a1.31,1.31,0,0,0-2.62,0V1.5H.374A.374.374,0,0,0,0,1.871V18.339a.374.374,0,0,0,.374.374H18.339a.374.374,0,0,0,.374-.374V1.871a.374.374,0,0,0-.374-.374M14.6,1.31a.561.561,0,1,1,1.123,0V2.433a.561.561,0,1,1-1.123,0V1.31Zm-11.6,0a.561.561,0,0,1,1.123,0V2.433a.561.561,0,0,1-1.123,0V1.31ZM.749,2.246h1.5v.187a1.31,1.31,0,0,0,2.62,0V2.246h8.982v.187a1.31,1.31,0,1,0,2.62,0V2.246h1.5V4.491H.749ZM17.965,17.965H.749V5.24H17.965Z",
    transform: "translate(0.167 0.286)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.6a1c7fb07a7ab05c94c65723c0954bd3.svg";
export { ForwardRef as ReactComponent };